module.exports = __webpack_public_path__ + "static/media/icon-play-video.5be3a81a.svg";